import type {
  ModelPageInfoBlocks,
  AutoFaqBlock,
  AutoFaqBlockItem,
  LinkBlock,
  LinkBlockItem,
  DynamicPageContext,
} from '~/interfaces/api';
import { useGlobalStore } from '~/stores/global';
import { useTimeCalculation } from '~/composition/useTimeCalculation';
import PresetsBasic from '~/components/presets-basic/PresetsBasic.vue';
import ProductsWithFilters from '~/components/listings/products-with-filters/ProductsWithFilters.vue';
import TopPresets from '~/components/ui/TopPresets.vue';
import UiLink from '~/components/ui/ui-link/ui-link.vue';
import HowToBuy from '~/components/ui/HowToBuy.vue';
import numWord from '~/common/num-word';

const ModelHistory = defineAsyncComponent(
  () => import('~/components/model-history/ModelHistory.vue')
);
const FaqImport = defineAsyncComponent(
  () => import('~/components/faq/faq.vue')
);
export default defineComponent({
  name: 'CategoryList',
  components: {
    HowToBuy,
    UiLink,
    ProductsWithFilters,
    ModelHistory,
    FaqImport,
    TopPresets,
    PresetsBasic,
  },
  props: {
    data: {
      type: Object as () => DynamicPageContext,
      required: true,
    },
    pageData: {
      type: Object as any,
      required: true,
    },
    seoData: {
      type: Object as any,
      required: true,
    },
    seoTextShow: Boolean,
  },
  setup(props) {
    const globalStore = useGlobalStore();
    const questions = ref<AutoFaqBlockItem[]>([]);
    const popularPreset = ref<LinkBlockItem[]>([]);
    const topPresetsItems = ref<LinkBlockItem[]>([]);
    const route = useRoute();
    const count = ref<number>(props.pageData?.total || 0);
    const isBot = computed(() => globalStore.isBot);
    const region_id = computed(() =>
      globalStore?.region?.id ? String(globalStore?.region?.id) : '1'
    );
    const dataCategoryId = computed(() => {
      const id = String(props.pageData?.selectedCategory?.id);
      if (id && id.length > 15 && id[id.length - 13] === '0') {
        return id.slice(0, -12).slice(0, -1) + id.slice(-12);
      }
      return id;
    });
    const isTitle = ref(props.data?.h1 || '');
    const params = {
      brand_id: props.data?.brand_id,
      preset_id: props.data?.preset_id,
    };
    const seoDescription = computed(
      () => globalStore.seoData?.page?.description || ''
    );
    const isPreset = computed(
      () => props.seoData?.page?.type === 'category-preset'
    );
    const blocks: ModelPageInfoBlocks = props.data.blocks || [];
    blocks.forEach((b) => {
      if (b.type === 'autofaq') questions.value = (<AutoFaqBlock>b).items;
      else if (b.label === 'preset') popularPreset.value = (<LinkBlock>b).items;
      else if (b.label === 'top_presets')
        topPresetsItems.value = (<LinkBlock>b).items;
    });
    const isDiscount = props.seoData?.page?.type === 'category-discount';
    const useSchema = computed(() => {
      return (
        props.pageData?.products &&
        props.pageData?.products.length > 0 &&
        props.pageData?.products[0].type === 'model'
      );
    });

    const ratings = computed(() => ({
      rating_value: props?.pageData?.ratings?.rating_value || 5,
      review_count: props?.pageData?.ratings?.review_count || 76,
      best_rating: props?.pageData?.ratings?.best_rating || 5,
      worst_rating: props?.pageData?.ratings?.worst_rating || 1,
    }));

    const firstCategoryImage = computed<string>(() => {
      return props.pageData?.products?.length
        ? props.pageData?.products[0]?.image
        : '';
    });
    const tabletCount = computed<string>(() => {
      return numWord(
        count.value,
        ['', 'товар', 'товара', 'товаров'],
        true,
        true,
        true
      );
    });
    const metaOffers = computed(() => ({
      offer_count: props.pageData?.total,
      price_max: props.pageData?.filters?.price?.max_value,
      price_min: props.pageData?.filters?.price?.min_value,
    }));
    useTimeCalculation();
    return {
      questions,
      popularPreset,
      topPresetsItems,
      route,
      count,
      isBot,
      isTitle,
      params,
      isDiscount,
      useSchema,
      ratings,
      firstCategoryImage,
      metaOffers,
      seoDescription,
      region_id,
      isPreset,
      dataCategoryId,
      tabletCount,
    };
  },
});
